import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatModule } from 'core/material/mat.module';
import { TranslationModule } from 'core/translation/translation.module';
import { DialogButtonsComponent } from './dialog-buttons.component';
import { DialogComponent } from './dialog.component';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { UnchangedPlaceholdersDialogComponent
       } from './unchanged-placeholders-dialog/unchanged-placeholders-dialog.component'; // tslint:disable-line
import { DeletePlaceholderDialogComponent
       } from './delete-placeholder-dialog/delete-placeholder-dialog.component';
import { SmartSortedDialogComponent
       } from './smart-sorted-dialog/smart-sorted-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatModule,
    FormsModule,
    TranslationModule,
  ],
  declarations: [
    DialogButtonsComponent,
    DialogComponent,
    ErrorDialogComponent,
    UnchangedPlaceholdersDialogComponent,
    DeletePlaceholderDialogComponent,
    SmartSortedDialogComponent,
  ],
  exports: [
    DialogButtonsComponent,
    DialogComponent,
    ErrorDialogComponent,
    UnchangedPlaceholdersDialogComponent,
    DeletePlaceholderDialogComponent,
    SmartSortedDialogComponent,
  ],
  entryComponents: [
    ErrorDialogComponent,
    UnchangedPlaceholdersDialogComponent,
    DeletePlaceholderDialogComponent,
    SmartSortedDialogComponent,
  ],
})
export class DialogsModule { }



// WEBPACK FOOTER //
// ./src/app/dialogs/dialogs.module.ts